<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;">
<!--    <Title :title="route"></Title>-->
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;" shadow="never">
      <el-form label-position="left" label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>
        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>
        <el-divider content-position="left">变更信息</el-divider>
        
        <div class="diff">
          <div class="child">
            <div class="tag">变更前</div>
            <div>项目名字：<span :id="diffProjectName+'_o_'+index" v-for="(i,index) in project.projectName">{{i}}</span></div>
            <div>预计金额：<span :id="diffMoney+'_o_'+index" v-for="(i,index) in project.projectAmountExpect">{{i}}</span></div>
            <div>项目状态：<span :id="diffState+'_o_'+index" v-for="(i,index) in projectState[project.projectState-1]">{{i}}</span></div>
            <div>项目负责人：<span :id="diffManager+'_o_'+index" v-for="(i,index) in project.managerName">{{i}}</span></div>
            <div>项目概况：<span :id="diffBody+'_o_'+index" v-for="(i,index) in surveys.surveyBody">{{i}}</span></div>
          </div>
          <div class="child">
            <div class="tag">变更后</div>
            <div>项目名字：<span :id="diffProjectName+index" v-for="(i,index) in projectModify.projectName">{{i}}</span></div>
            <div>预计金额：<span :id="diffMoney+index" v-for="(i,index) in projectModify.projectAmountExpect">{{i}}</span></div>
            <div>项目状态：<span :id="diffState+index" v-for="(i,index) in projectState[projectModify.projectState-1]">{{i}}</span></div>
            <div>项目负责人：<span :id="diffManager+index" v-for="(i,index) in projectModify.managerName">{{i}}</span></div>
            <div>项目概况：<span :id="diffBody+index" v-for="(i,index) in projectModify.surveyBody">{{i}}</span></div>
          </div>
        </div>
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit===true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input
              type="textarea" rows="5"
              maxlength="500" show-word-limit
              v-model="ruleForm.auditOpinion">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <Setp :nodes="nodes" :audits="audits"></Setp>
  </div>
</template>

<script>
import {diff} from "@/util/diff.js"
import Title from "../../Title";
import Setp from "../common/Setp";
import AuditList from "../common/AuditList";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
export default {
  components: {Title,Setp, AuditList},
  name: "ProjectModifyDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '项目变更申请',
        path: ''
      },
      user: {},
      nodes: [],
      audits: [],
      isPass: Boolean,
      auditHistory: [],
      allowAudit: false,
      project: {
        projectName: ""
      },
      projectModify: {
        projectName: ""
      },
      surveys: {},
      ruleForm: {
        auditOpinion: "",
      },
      diffProjectName: "d_name",
      diffMoney: "d_momey",
      diffState: "d_state",
      diffManager: "d_manager",
      diffBody: "d_body",
      projectState: [
        "已沟通","已采购","已签约","已回款","已实施","项目终止", "已完成"
      ]
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.param = {
      applyId: this.query.applyId,
      applyServiceId: this.query.applyServiceId,
      applyType: this.query.applyType
    }
    this.getObject()
    this.getAuditShow()
  },
  updated() {
    this.textDiff()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({applyId: this.param.applyId}).then(res => {
        if (res.code === 200) {
          this.allowAudit = res.object === 1
        }
      })
    },
    async audit(isAgree) {
      this.allowAudit = false
      let param = this.param
      param.auditOpinion = isAgree === 2 ? "同意" : "不同意"
      if (this.ruleForm.auditOpinion) {
        param.auditOpinion = this.ruleForm.auditOpinion
      }
      param.isAgree = isAgree
      const res = await requestAudit(param)
      if (res.code === 200) {
        this.getAuditShow()
        await this.getObject()
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    async getObject() {
      const res = await requestApplyDetail(this.param)
      if (res.code === 200) {
        if (res.object) {
          this.audits = res.object.audits
          this.auditHistory = res.object.auditHistory
          this.user = res.object.user
          this.nodes = res.object.nodes
          let surveys = res.object.surveys
          this.surveys = surveys[surveys.length-1]
          //this.isPass = res.object.isPass
          if (res.object.isPass) {
            this.project = res.object.projectModify
            this.project.projectAmountExpect = res.object.projectModify.projectAmountExpect.toString()
            this.projectModify = res.object.project
            this.projectModify.projectAmountExpect = res.object.project.projectAmountExpect.toString()
            this.projectModify.surveyBody = res.object.projectModify.surveyBody
          } else {
            this.project = res.object.project
            this.project.projectAmountExpect = res.object.project.projectAmountExpect.toString()
            this.projectModify = res.object.projectModify
            this.projectModify.projectAmountExpect = res.object.projectModify.projectAmountExpect.toString()
          }
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    textDiff() {
      // 项目名字对比
      let s1 = this.project.projectName
      let s2 = this.projectModify.projectName
      this.projectDiff(s1,s2, this.diffProjectName)
      // 预计金额对比
      let s3 = this.project.projectAmountExpect
      let s4 = this.projectModify.projectAmountExpect
      this.projectDiff(s3,s4, this.diffMoney)
      // 项目状态对比
      let s5 = this.projectState[this.project.projectState-1]
      let s6 = this.projectState[this.projectModify.projectState-1]
      this.projectDiff(s5,s6, this.diffState)

      // surveys.surveyBody project.managerName
      let s7 = this.project.managerName
      let s8 = this.projectModify.managerName
      this.projectDiff(s7,s8,this.diffManager)

      let s9 = this.surveys.surveyBody
      let s0 = this.projectModify.surveyBody
      this.projectDiff(s9,s0,this.diffBody)
    },
    projectDiff(s1, s2, diffName) {
      const res = diff(s1,s2)
      let modify = res[1]
      let o = res[0]
      for (let i = 0; i < o.length; i++) {
        if (o[i] === 0) {
          const name = diffName + "_o_" + i
          const node = document.getElementById(name)
          node.style.backgroundColor = "rgb(225, 243, 216)"
          node.style.textDecorationColor = "red"
        }
      }
      for (let i = 0; i < modify.length; i++) {
        if (modify[i] === 0) {
          const name = diffName + i
          const node = document.getElementById(name)
          node.style.backgroundColor = "rgb(250, 236, 216)"
        }
      }
    }
  }
}
</script>

<style>
.diff {
  display: flex;
}
.child {
  width: 50%;
}
.child div {
  margin-top: 4px;
}
.tag {
  color: #409EFF;
  font-size: 18px;
}
</style>